import { useQuery } from "react-query"
import { getTotalUser } from "../../../models/statistics"
import SummaryCard from "./SummaryCard"


const TotalUser = () => {
    const { isLoading, isError, error, data: { data } = {} } = useQuery('statistic-total-user', getTotalUser)

    return (
        <SummaryCard
            label="Total Users"
            value={data?.total_user ? data.total_user.toLocaleString('id-ID') : 0}
            icon="/media/icons/duotune/communication/com006.svg"
            isLoading={isLoading}
            isError={isError}
            error={error}
        />
    )
}

export default TotalUser